export default "__VITE_ASSET__D_ZCBA13__";